import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    placeholder: string;
    clearButtonAriaLabel: string;
    pendingStateLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder text for the search input */
            placeholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SearchField.placeholder?c=3urfhu5j4omas", defaultMessage: "Search" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the search input clear button */
            clearButtonAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SearchField.clearButtonAriaLabel?c=2rge8o29expna", defaultMessage: "Clear input value" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label shown while search is in progress */
            pendingStateLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SearchField.pendingStateLabel?c=2xzqohvscs9ht", defaultMessage: "Searching" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
